const noop = ()=>null;

export { noop };
//# sourceMappingURL=noop.mjs.map
